import { getGroupInformation } from "owa-groups-shared-store/lib/selectors/getGroupInformation";
import { getUserMailboxInfo } from "owa-client-ids";

export function getGroupDisplayName(groupId: string | null): string {
    if (!groupId) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (8,9): Type 'null' is not assignable to type 'string'.
        // @ts-expect-error
        return null;
    }
    
    /* eslint-disable-next-line owa-custom-rules/no-default-methods  -- (https://aka.ms/OWALintWiki)
     * Methods that use the default mailbox should not be used, see https://aka.ms/multiaccountlinter
     *	> Do Not Use Default: The getUserMailboxInfo function should not be used for Respond multi-account support, user identity is not enough to identify account information. */
    const group = getGroupInformation(getUserMailboxInfo(), groupId);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (16,5): Type 'string | undefined' is not assignable to type 'string'.
    // @ts-expect-error
    return group?.basicInformation ? group.basicInformation.DisplayName : groupId;
}
